import { useState } from "react";

export enum pageNames {
  top,
  loading,
  group,
  sync,
  message,
  products,
}
export const initialPos: {
  page: pageNames;
  index: number;
  message?: { type: "q" | "e" | "s" | "l" | "i"; k: string };
  scroll: { y: number };
} = {
  page: pageNames.loading,
  index: 0,
  scroll: { y: 0 },
};

export const usePos = () => {
  const [pos, setPos] = useState(initialPos);
  const changePos = (props: {
    page?: pageNames;
    index?: number;
    message?: { type: "q" | "e" | "s" | "l" | "i"; k: string };
    noPush?: boolean;
  }) => {
    if (!props.noPush) {
      /* eslint-disable */
      props.page !== undefined &&
        history.pushState(
          null,
          "",
          `/${pageNames[props.page]}${props.index !== undefined ? `/${props.index}` : ""}`,
        );
      /* eslint-enable */
    }
    setPos((prev) => {
      const y =
        prev.page === pageNames.top ? { scroll: { y: window.scrollY } } : {};
      return { ...prev, ...props, ...y };
    });
  };

  return { pos, changePos };
};

export type posType = ReturnType<typeof usePos>;
